import { jsx as n, jsxs as g, Fragment as w } from "react/jsx-runtime";
import { withManagedProps as A } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as v } from "@made-people/react-prop-guard";
import { logoBlueprint as he, menuTriggerBlueprint as Te, cartTriggerBlueprint as fe, accountTriggerBlueprint as pe, template1Styling as R, searchTriggerBlueprint as ve, template2Styling as x, template3Styling as j, template4Styling as H, bareboneBlueprint as q } from "./index-blueprint.es.js";
import { TRYLogo as ye, BurgerIcon as Se, CartIcon as Ne, UserIcon as Ce, MagnifierIcon as Ie, CrossIcon as ke } from "@made-people/blueprint-icons";
import { useLink as Z } from "@made-people/grease-link";
import k from "clsx";
import { buttonContentPropsSchema as J, Button as U } from "@made-people/blueprint-button";
import { overlayEventEmitter as $ } from "@made-people/blueprint-overlay";
import { useMemo as z, useState as L, useEffect as X, useRef as we, useCallback as ie } from "react";
import { useCartState as xe } from "@made-people/grease-cart";
import { motion as oe, AnimatePresence as je } from "motion/react";
import { stickyWrapperSchema as D, StickyWrapper as O } from "@made-people/blueprint-sticky-wrapper";
import { searchInputSchema as re, SearchInput as ce } from "@made-people/blueprint-search";
import { siteSettingsTriggerSchema as ee, SiteSettingsTrigger as te } from "@made-people/blueprint-site-settings";
import "@made-people/blueprint";
const P = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  svg: e.custom().optional(),
  className: e.string().optional()
}), Q = v(
  {
    schema: P,
    defaultProps: {
      enabled: !0,
      svg: /* @__PURE__ */ n(ye, {})
    }
  },
  ({ blueprint: l, variants: o, svg: b, enabled: s, className: i }) => {
    const t = Z(), a = (l ?? he).styles(o);
    return s ? /* @__PURE__ */ n("div", { className: k(a.wrapper, i), children: /* @__PURE__ */ n(t, { className: a.link, href: "", "aria-label": "Go to home", children: b }) }) : null;
  }
), K = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  overlayId: e.string().optional(),
  className: e.string().optional()
}), ne = v(
  {
    schema: K,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Menu"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ n(Se, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: o, enabled: b, className: s, ...i }) => {
    var a, r, d, c, h, m;
    const u = (l ?? Te).styles(o);
    return b === !1 ? null : /* @__PURE__ */ g(
      "div",
      {
        className: k(u.wrapper, s),
        onClick: () => $.emit("open", {
          overlayId: i.overlayId
        }),
        children: [
          !((a = i.button) != null && a.enabled) && /* @__PURE__ */ g(w, { children: [
            ((r = i.icon) == null ? void 0 : r.enabled) && /* @__PURE__ */ n("span", { className: u.icon, children: i.icon.iconSvg }),
            ((d = i.label) == null ? void 0 : d.enabled) && /* @__PURE__ */ n("span", { className: u.label, children: i.label.labelText })
          ] }),
          ((c = i.button) == null ? void 0 : c.enabled) && /* @__PURE__ */ n(
            U,
            {
              as: "span",
              label: ((h = i.label) == null ? void 0 : h.enabled) && i.label.labelText,
              iconLeft: ((m = i.icon) == null ? void 0 : m.enabled) && i.icon.iconSvg,
              ...i.button.settings
            }
          )
        ]
      }
    );
  }
), B = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  qtyDisplay: e.enum(["total_quantity", "total_items"]).optional(),
  animateQtyOnUpdate: e.boolean().optional(),
  type: e.enum(["mini-cart", "link-to-checkout"]).optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  className: e.string().optional()
}), F = v(
  {
    schema: B,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Cart"
      },
      type: "link-to-checkout",
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ n(Ne, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: o, enabled: b, type: s, className: i, ...t }) => {
    var I;
    const a = (l ?? fe).styles(o), { cart: r } = xe(), d = Z(), c = z(() => t.qtyDisplay === "total_items" ? r == null ? void 0 : r.items.length : r == null ? void 0 : r.items.reduce((f, p) => f + p.quantity, 0), [r, t.qtyDisplay]), [h, m] = L(c), [T, S] = L(!1);
    X(() => {
      if (h !== null && c !== h && t.animateQtyOnUpdate) {
        S(!0);
        const f = setTimeout(() => S(!1), 500);
        return m(c), () => clearTimeout(f);
      }
    }, [c]);
    const N = z(
      () => {
        var f, p, y;
        return /* @__PURE__ */ n(
          U,
          {
            as: s === "link-to-checkout" ? "a" : "button",
            link: s === "link-to-checkout" ? { href: "checkout" } : void 0,
            onClick: s === "mini-cart" ? () => $.emit("open", { overlayId: "mini-cart" }) : void 0,
            iconLeft: ((f = t.icon) == null ? void 0 : f.enabled) && t.icon.iconSvg,
            iconRight: /* @__PURE__ */ n(
              le,
              {
                qty: c,
                className: a.counter,
                shouldAnimate: T
              }
            ),
            label: ((p = t.label) == null ? void 0 : p.enabled) && t.label.labelText,
            ...(y = t == null ? void 0 : t.button) == null ? void 0 : y.settings,
            className: i
          }
        );
      },
      [s, t.icon, t.label, a.counter, c, T]
    ), C = z(() => {
      var p, y;
      const f = /* @__PURE__ */ g(w, { children: [
        ((p = t.icon) == null ? void 0 : p.enabled) && /* @__PURE__ */ n("span", { className: a.icon, children: t.icon.iconSvg }),
        ((y = t.label) == null ? void 0 : y.enabled) && /* @__PURE__ */ n("span", { className: a.label, children: t.label.labelText }),
        /* @__PURE__ */ n(
          le,
          {
            qty: c,
            className: a.counter,
            shouldAnimate: T
          }
        )
      ] });
      return s === "link-to-checkout" ? /* @__PURE__ */ n(
        d,
        {
          href: "checkout",
          className: k(a.wrapper, i),
          "aria-label": "Go to checkout",
          children: f
        }
      ) : /* @__PURE__ */ n(
        "button",
        {
          className: k(a.wrapper, i),
          onClick: () => $.emit("open", { overlayId: "mini-cart" }),
          children: f
        }
      );
    }, [s, t.icon, t.label, a, c, T]);
    return b ? (I = t.button) != null && I.enabled ? N : C : null;
  }
), le = ({
  qty: l,
  className: o,
  shouldAnimate: b
}) => /* @__PURE__ */ n(
  oe.span,
  {
    className: o,
    animate: b ? { scale: [1, 0.9, 1.2, 0.8, 1] } : { scale: 1 },
    transition: {
      duration: 0.4,
      ease: "easeOut"
      // times: [0, 0.2, 0.6, 0.8, 1], // Custom timing for each keyframe
    },
    children: l
  }
), E = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  className: e.string().optional(),
  href: e.string().optional(),
  loggedIn: e.object({
    isLoggedIn: e.boolean().optional(),
    showInitials: e.boolean().optional(),
    label: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional()
  }).optional()
}), G = v(
  {
    schema: E,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "My Account"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ n(Ce, {})
      },
      button: {
        enabled: !1
      },
      loggedIn: {
        isLoggedIn: !1,
        showInitials: !0
      }
    }
  },
  ({ blueprint: l, variants: o, enabled: b, className: s, href: i, ...t }) => {
    var c, h, m, T, S, N, C, I, f, p, y, M, ae;
    const a = (l ?? pe).styles(o);
    if (b === !1 || i === void 0)
      return null;
    const r = Z(), d = (c = t.loggedIn) != null && c.showInitials ? Le(t.loggedIn.firstName, t.loggedIn.lastName) : "";
    return /* @__PURE__ */ g(w, { children: [
      !((h = t.loggedIn) != null && h.isLoggedIn) && /* @__PURE__ */ g("div", { className: k(a.wrapper, s), children: [
        !((m = t.button) != null && m.enabled) && /* @__PURE__ */ g(r, { href: i, "aria-label": "Go to account", children: [
          ((T = t.icon) == null ? void 0 : T.enabled) && /* @__PURE__ */ n("span", { className: a.icon, children: t.icon.iconSvg }),
          ((S = t.label) == null ? void 0 : S.enabled) && /* @__PURE__ */ n("span", { className: a.label, children: t.label.labelText })
        ] }),
        ((N = t.button) == null ? void 0 : N.enabled) && /* @__PURE__ */ n(
          U,
          {
            as: "a",
            link: { href: i },
            iconLeft: ((C = t.icon) == null ? void 0 : C.enabled) && t.icon.iconSvg,
            label: ((I = t.label) == null ? void 0 : I.enabled) && t.label.labelText,
            ...t.button.settings
          }
        )
      ] }),
      ((f = t.loggedIn) == null ? void 0 : f.isLoggedIn) && /* @__PURE__ */ g("div", { className: k(a.wrapper, s), children: [
        !((p = t.button) != null && p.enabled) && /* @__PURE__ */ g(r, { href: i, children: [
          ((y = t.icon) == null ? void 0 : y.enabled) && /* @__PURE__ */ n("span", { className: a.icon, children: /* @__PURE__ */ n("span", { className: a.loggedInInitials, children: d }) }),
          t.loggedIn.label && /* @__PURE__ */ n("span", { className: a.label, children: t.loggedIn.label })
        ] }),
        ((M = t.button) == null ? void 0 : M.enabled) && /* @__PURE__ */ n(
          U,
          {
            as: "a",
            link: { href: i },
            iconLeft: ((ae = t.icon) == null ? void 0 : ae.enabled) && /* @__PURE__ */ n("span", { className: a.loggedInInitials, children: d }),
            label: t.loggedIn.label && t.loggedIn.label,
            ...t.button.settings
          }
        )
      ] })
    ] });
  }
);
function Le(l, o) {
  const b = (l == null ? void 0 : l[0]) ?? "", s = (o == null ? void 0 : o[0]) ?? "";
  return `${b}${s}`.toUpperCase();
}
const W = e.union([
  e.literal("mobile"),
  e.literal("tablet"),
  e.literal("desktop"),
  e.literal("none"),
  e.array(e.enum(["mobile", "tablet", "desktop"]))
]).optional();
function Y(l) {
  const o = {
    "data-screen-mobile": "hidden",
    "data-screen-tablet": "hidden",
    "data-screen-desktop": "hidden"
  };
  return l ? (Array.isArray(l) ? l : [l]).forEach((s) => {
    s === "mobile" ? o["data-screen-mobile"] = "visible" : s === "tablet" ? o["data-screen-tablet"] = "visible" : s === "desktop" && (o["data-screen-desktop"] = "visible");
  }) : (o["data-screen-mobile"] = "visible", o["data-screen-tablet"] = "visible", o["data-screen-desktop"] = "visible"), o;
}
const se = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: K.optional().describe("Configure the Menu Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search
   */
  search: re.optional().describe("Configure the Search"),
  /**
   * Define visibility per breakpoint
   */
  visibility: W,
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  stickyType: D.shape.type.optional()
}), Ae = A(
  "HeaderTemplate1",
  v(
    se,
    ({
      variants: l,
      cartTrigger: o,
      menuTrigger: b,
      accountTrigger: s,
      menu: i,
      topbar: t,
      stickyType: u,
      ...a
    }) => {
      const r = R.main.styles(l);
      return /* @__PURE__ */ g(
        O,
        {
          className: r.wrapper,
          type: u,
          ...Y(a == null ? void 0 : a.visibility),
          children: [
            t && t,
            /* @__PURE__ */ g("div", { className: r.nav, children: [
              /* @__PURE__ */ g("div", { className: r.left, children: [
                /* @__PURE__ */ n(
                  ne,
                  {
                    ...b,
                    blueprint: R.menuTrigger
                  }
                ),
                i && i,
                /* @__PURE__ */ n("div", { className: r.search, children: /* @__PURE__ */ n(ce, { ...a.search }) })
              ] }),
              /* @__PURE__ */ n("div", { className: r.center, children: /* @__PURE__ */ n(Q, { ...a.logo, blueprint: R.logo }) }),
              /* @__PURE__ */ g("div", { className: r.right, children: [
                /* @__PURE__ */ n(
                  G,
                  {
                    ...s,
                    blueprint: R.accountTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  F,
                  {
                    ...o,
                    blueprint: R.cartTrigger
                  }
                )
              ] })
            ] })
          ]
        }
      );
    }
  )
), _ = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  /**
   * @property {string} [searchRoute] - An optional string representing the search route.
   */
  searchRoute: e.string().optional(),
  onStateChange: e.custom().optional(),
  icons: e.object({
    default: e.custom().or(e.literal(!1)).optional(),
    close: e.custom().or(e.literal(!1)).optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: J.optional()
  }).optional(),
  className: e.string().optional()
}), V = v(
  {
    schema: _,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Search"
      },
      icons: {
        default: /* @__PURE__ */ n(Ie, {}),
        close: /* @__PURE__ */ n(ke, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: o, enabled: b, className: s, onStateChange: i, ...t }) => {
    var S, N;
    const a = (l ?? ve).styles(o), r = Z(), [d, c] = L(!1), h = d ? (S = t == null ? void 0 : t.icons) == null ? void 0 : S.close : (N = t == null ? void 0 : t.icons) == null ? void 0 : N.default;
    if (b === !1)
      return null;
    const m = () => {
      $.emit("open", { overlayId: "search-sidebar" });
    }, T = () => {
      var C, I, f, p, y, M;
      return /* @__PURE__ */ g(w, { children: [
        !((C = t.button) != null && C.enabled) && /* @__PURE__ */ g(w, { children: [
          ((I = t.icons) == null ? void 0 : I.default) && /* @__PURE__ */ n("span", { className: a.icon, children: h }),
          ((f = t.label) == null ? void 0 : f.enabled) && /* @__PURE__ */ n("span", { className: a.label, children: t.label.labelText })
        ] }),
        ((p = t.button) == null ? void 0 : p.enabled) && /* @__PURE__ */ n(
          U,
          {
            as: "span",
            label: ((y = t.label) == null ? void 0 : y.enabled) && t.label.labelText,
            iconLeft: ((M = t.icons) == null ? void 0 : M.default) && h,
            ...t.button.settings
          }
        )
      ] });
    };
    return /* @__PURE__ */ g(w, { children: [
      t.searchRoute && /* @__PURE__ */ n(
        r,
        {
          href: t.searchRoute,
          className: k(a.wrapper, s),
          children: T()
        }
      ),
      !t.searchRoute && /* @__PURE__ */ n(
        "span",
        {
          className: k(a.wrapper, s),
          onClick: m,
          children: T()
        }
      )
    ] });
  }
), ge = e.object({
  variants: e.custom().optional(),
  logo: P.optional().describe("Configure the Logo"),
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  menuTrigger: K.optional().describe("Configure the Menu Trigger"),
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  searchTrigger: _.optional().describe("Configure the Search Trigger"),
  siteSettingsTrigger: ee.optional(),
  visibility: W,
  menu: e.custom().optional(),
  topbar: e.custom().optional(),
  stickyType: D.shape.type.optional()
}), Pe = A(
  "HeaderTemplate2",
  v(
    {
      schema: ge,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: o,
      menuTrigger: b,
      accountTrigger: s,
      searchTrigger: i,
      siteSettingsTrigger: t,
      menu: u,
      topbar: a,
      stickyType: r,
      ...d
    }) => {
      const c = x.main.styles(l), [h, m] = L(!1), T = we(null), S = z(
        () => ({
          // Remove dynamic height calculations - let CSS handle it
          overflow: "hidden"
        }),
        []
      ), N = ie((C) => {
        requestAnimationFrame(() => {
          m(C);
        });
      }, []);
      return /* @__PURE__ */ n(w, { children: /* @__PURE__ */ g(
        O,
        {
          forwardedRef: T,
          className: c.wrapper,
          type: r,
          ...Y(d == null ? void 0 : d.visibility),
          style: S,
          children: [
            a && a,
            /* @__PURE__ */ g("div", { className: c.nav, children: [
              /* @__PURE__ */ g("div", { className: c.left, children: [
                /* @__PURE__ */ n(
                  ne,
                  {
                    ...b,
                    blueprint: x.menuTrigger
                  }
                ),
                u && u,
                /* @__PURE__ */ n(
                  V,
                  {
                    ...i,
                    blueprint: x.searchTrigger,
                    onStateChange: N
                  }
                )
              ] }),
              /* @__PURE__ */ n("div", { className: c.center, children: /* @__PURE__ */ n(Q, { ...d.logo, blueprint: x.logo }) }),
              /* @__PURE__ */ g("div", { className: c.right, children: [
                /* @__PURE__ */ n(
                  te,
                  {
                    ...t,
                    className: c.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  G,
                  {
                    ...s,
                    blueprint: x.accountTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  F,
                  {
                    ...o,
                    blueprint: x.cartTrigger
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ n(je, { mode: "wait", children: h && /* @__PURE__ */ n(
              oe.div,
              {
                className: "w-full z-30 px-component-spacing-sm pb-3",
                initial: { height: 0, opacity: 0 },
                animate: {
                  height: "auto",
                  opacity: 1,
                  transition: {
                    height: { duration: 0.3, ease: [0.19, 1, 0.22, 1] },
                    opacity: { duration: 0.2, delay: 0.1 }
                  }
                },
                exit: {
                  height: 0,
                  opacity: 0,
                  transition: {
                    height: { duration: 0.2, ease: "easeOut" },
                    opacity: { duration: 0.15 }
                  }
                },
                style: { overflow: "hidden" },
                children: /* @__PURE__ */ n(
                  ce,
                  {
                    autoComplete: { enabled: !0 },
                    autoFocus: !0
                  }
                )
              }
            ) })
          ]
        }
      ) });
    }
  )
), de = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: K.optional().describe("Configure the Menu Trigger"),
  /**
   * Configure the Menu Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: _.optional().describe("Configure the Search Trigger"),
  /**
   * Define visibility per breakpoint
   */
  visibility: W,
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  stickyType: D.shape.type.optional()
}), Be = A(
  "HeaderTemplate3",
  v(
    de,
    ({
      variants: l,
      cartTrigger: o,
      menuTrigger: b,
      accountTrigger: s,
      searchTrigger: i,
      menu: t,
      topbar: u,
      stickyType: a,
      ...r
    }) => {
      const d = j.main.styles(l);
      return /* @__PURE__ */ g(
        O,
        {
          className: d.wrapper,
          type: a,
          ...Y(r == null ? void 0 : r.visibility),
          children: [
            u && u,
            /* @__PURE__ */ g("div", { className: d.nav, children: [
              /* @__PURE__ */ n("div", { className: d.left, children: /* @__PURE__ */ n(Q, { ...r.logo, blueprint: j.logo }) }),
              /* @__PURE__ */ g("div", { className: d.right, children: [
                /* @__PURE__ */ n(
                  V,
                  {
                    ...i,
                    blueprint: j.searchTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  G,
                  {
                    ...s,
                    blueprint: j.accountTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  F,
                  {
                    ...o,
                    blueprint: j.cartTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  ne,
                  {
                    ...b,
                    blueprint: j.menuTrigger
                  }
                ),
                t && t
              ] })
            ] })
          ]
        }
      );
    }
  )
), be = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Country Selector
   */
  siteSettingsTrigger: ee.optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: _.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: W,
  stickyType: D.shape.type.optional()
}), Ee = A(
  "HeaderTemplate4",
  v(
    {
      schema: be,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: o,
      searchTrigger: b,
      accountTrigger: s,
      siteSettingsTrigger: i,
      menu: t,
      topbar: u,
      stickyType: a,
      ...r
    }) => {
      const [d, c] = L(!1), h = ie(() => {
        c(window.scrollY > 100);
      }, []);
      X(() => (window.addEventListener("scroll", h), () => {
        window.removeEventListener("scroll", h);
      }), []);
      const m = H.main.styles(l);
      return /* @__PURE__ */ g(
        O,
        {
          className: m.wrapper,
          type: a,
          ...Y(r == null ? void 0 : r.visibility),
          "data-scrolled": d,
          children: [
            u && u,
            /* @__PURE__ */ g("div", { className: m.nav, children: [
              /* @__PURE__ */ g("div", { className: m.left, children: [
                /* @__PURE__ */ n(Q, { ...r.logo, blueprint: H.logo }),
                t && t
              ] }),
              /* @__PURE__ */ g("div", { className: m.right, children: [
                /* @__PURE__ */ n(
                  te,
                  {
                    ...i,
                    className: m.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  V,
                  {
                    ...b,
                    blueprint: H.searchTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  G,
                  {
                    ...s,
                    blueprint: H.accountTrigger
                  }
                ),
                /* @__PURE__ */ n(
                  F,
                  {
                    ...o,
                    blueprint: H.cartTrigger
                  }
                )
              ] })
            ] })
          ]
        }
      );
    }
  )
), ue = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: _.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: W,
  siteSettingsTrigger: ee.optional(),
  stickyType: D.shape.type.optional(),
  search: re.optional().describe("Configure the Search")
}), Me = A(
  "HeaderBarebone",
  v(
    {
      schema: ue,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: o,
      searchTrigger: b,
      accountTrigger: s,
      siteSettingsTrigger: i,
      menu: t,
      topbar: u,
      stickyType: a,
      search: r,
      ...d
    }) => {
      const c = q.main.styles(l), [h, m] = L(!1);
      return X(() => {
        const T = () => {
          m(window.scrollY > 100);
        };
        return window.addEventListener("scroll", T), () => {
          window.removeEventListener("scroll", T);
        };
      }, []), /* @__PURE__ */ g(
        O,
        {
          className: c.wrapper,
          type: a,
          ...Y(d == null ? void 0 : d.visibility),
          "data-scrolled": h,
          children: [
            u && u,
            /* @__PURE__ */ g("div", { className: c.nav, children: [
              /* @__PURE__ */ n(
                Q,
                {
                  ...d.logo,
                  blueprint: q.logo,
                  className: c.logoPosition
                }
              ),
              t && /* @__PURE__ */ n("div", { className: c.menuPosition, children: t }),
              /* @__PURE__ */ n(
                te,
                {
                  ...i,
                  className: c.siteSettingsTriggerPosition
                }
              ),
              /* @__PURE__ */ n(
                V,
                {
                  ...b,
                  blueprint: q.searchTrigger,
                  className: c.searchTriggerPosition
                }
              ),
              /* @__PURE__ */ n(
                G,
                {
                  ...s,
                  blueprint: q.accountTrigger,
                  className: c.accountTriggerPosition
                }
              ),
              /* @__PURE__ */ n(
                F,
                {
                  ...o,
                  blueprint: q.cartTrigger,
                  className: c.cartTriggerPosition
                }
              )
            ] })
          ]
        }
      );
    }
  )
), me = e.discriminatedUnion("template", [
  se.extend({
    template: e.literal("template1")
  }),
  ge.extend({
    template: e.literal("template2")
  }),
  de.extend({
    template: e.literal("template3")
  }),
  be.extend({
    template: e.literal("template4")
  }),
  ue.extend({
    template: e.literal("barebone")
  })
]), Re = v(me, (l) => {
  switch (l.template) {
    case "template1":
      return /* @__PURE__ */ n(Ae, { ...l });
    case "template2":
      return /* @__PURE__ */ n(Pe, { ...l });
    case "template3":
      return /* @__PURE__ */ n(Be, { ...l });
    case "template4":
      return /* @__PURE__ */ n(Ee, { ...l });
    case "barebone":
      return /* @__PURE__ */ n(Me, { ...l });
    default:
      return null;
  }
}), He = "template2", qe = e.object({
  settings: me.optional()
}), tt = A(
  "Header",
  v({ schema: qe, defaultProps: {} }, (l) => {
    const o = l.settings || { template: He };
    return /* @__PURE__ */ n(Re, { ...o });
  })
);
export {
  G as AccountTrigger,
  F as CartTrigger,
  tt as Header,
  Me as HeaderBarebone,
  Q as Logo,
  ne as MenuTrigger,
  V as SearchTrigger,
  Re as SelectTemplate,
  Ae as Template1,
  Pe as Template2,
  Be as Template3,
  Ee as Template4,
  E as accountTriggerSchema,
  ue as bareboneSchema,
  W as breakpointsSchema,
  B as cartTriggerSchema,
  qe as headerPropsSchema,
  me as headerSchema,
  P as logoSchema,
  K as menuTriggerSchema,
  _ as searchTriggerSchema,
  Y as setBreakpointDataAttributes,
  se as template1Schema,
  ge as template2Schema,
  de as template3Schema,
  be as template4Schema
};
//# sourceMappingURL=index.es.js.map
